<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户登录历史</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="请输入用户ID" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入登录IP" clearable v-model="ip">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入设备ID" clearable v-model="phoneId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="type" @change="changeType($event)" placeholder="请筛选设备类型">
          <el-option value="" label="全部类型">全部类型</el-option>
          <el-option v-for="item in loginTypesOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="value1" type="daterange" align="right" format="yyyy-MM-dd" value-format="timestamp"
          unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime($event)"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
export default {
  name: "userLoginLog",
  components: {
    UserList,
  },
  data() {
    return {
      userId: "",
      ip: "",
      phoneId: "",
      type: "",
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      value1: "",
      loginTypesOption: [
        { value: "WEB", label: "WEB" },
        { value: "IPHONE", label: "IPHONE" },
        { value: "COMPUTER", label: "COMPUTER" },
        { value: "ANDROID", label: "ANDROID" },
        { value: "H5", label: "H5" },

      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("userLoginLog", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("userLoginLog", ["list"]),
    refreshList(data = {}) {
      this.list({
        userId: this.userId,
        ip: this.ip,
        phoneId: this.phoneId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.list({
        userId: this.userId,
        ip: this.ip,
        phoneId: this.phoneId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    changeType(e) {
      console.log("e", e);
      this.list({
        userId: this.userId,
        ip: this.ip,
        phoneId: this.phoneId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    handleSearch() {
      this.list({
        userId: this.userId,
        ip: this.ip,
        phoneId: this.phoneId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() { },
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    this.list({
      userId: this.userId,
      ip: this.ip,
      phoneId: this.phoneId,
      type: this.type,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" scoped></style>
